// i18n
import 'src/locales/i18n';

// highlight
import 'src/utils/highlight';

// scroll bar
import 'simplebar/src/simplebar.css';

// lightbox
import 'react-image-lightbox/style.css';

// map
import 'mapbox-gl/dist/mapbox-gl.css';

// editor
import 'react-quill/dist/quill.snow.css';

// slick-carousel
import 'slick-carousel/slick/slick-theme.css';
import 'slick-carousel/slick/slick.css';

// lazy image
import 'react-lazy-load-image-component/src/effects/black-and-white.css';
import 'react-lazy-load-image-component/src/effects/blur.css';
import 'react-lazy-load-image-component/src/effects/opacity.css';

// fullcalendar
import '@fullcalendar/common/main.min.css';
import '@fullcalendar/daygrid/main.min.css';
import 'src/theme/adminReport.css';

import cookie from 'cookie';
import PropTypes from 'prop-types';
// next
import App from 'next/app';
import Head from 'next/head';
//
import { Provider as ReduxProvider } from 'react-redux';
import { PersistGate } from 'redux-persist/lib/integration/react';
// @mui
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'

// redux
import { persistor, store } from 'src/redux/store';
// utils
import { getSettings } from 'src/utils/settings';
// contexts
import { CollapseDrawerProvider } from 'src/contexts/CollapseDrawerContext';
import { SettingsProvider } from 'src/contexts/SettingsContext';
// theme
import ThemeProvider from 'src/theme';
// components
// import Settings from 'src/components/settings';
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import MotionLazyContainer from 'src/components/animate/MotionLazyContainer';
import { ChartStyle } from 'src/components/chart';
import NotistackProvider from 'src/components/NotistackProvider';
import ProgressBar from 'src/components/ProgressBar';
import RtlLayout from 'src/components/RtlLayout';
import ThemeColorPresets from 'src/components/ThemeColorPresets';
import ThemeLocalization from 'src/components/ThemeLocalization';
import "react-chat-elements/dist/main.css"

// Check our docs

// import { AuthProvider } from 'src/contexts/Auth0Context';
// import { AuthProvider } from 'src/contexts/FirebaseContext';
// import { AuthProvider } from 'src/contexts/AwsCognitoContext';

// ----------------------------------------------------------------------

import ModalProvider from 'src/component/modal/ModalProvider';
import BlockingLoader from '@components/BlockingLoader';
import { StepperProvider } from '@components/stepper/stepperContext';
import { DateTimeProvider } from 'src/contexts/DateTimeContext';

MyApp.propTypes = {
  Component: PropTypes.func,
  pageProps: PropTypes.object,
  settings: PropTypes.object,
};

export default function MyApp(props) {
  const { Component, pageProps, settings } = props;

  const getLayout = Component.getLayout ?? ((page) => page);

  return (
    <>
      <Head>
        <meta name="viewport" content="initial-scale=1, width=device-width" />
      </Head>


      <ReduxProvider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <CollapseDrawerProvider>
              <DateTimeProvider>
                <SettingsProvider defaultSettings={settings}>
                  <ThemeProvider>
                    <StepperProvider>
                      <NotistackProvider>
                        <MotionLazyContainer>
                          <ThemeColorPresets>
                            <ThemeLocalization>
                              <RtlLayout>
                                <ChartStyle />
                                {/* <Settings /> */}
                                <ProgressBar />
                                <ModalProvider>
                                  {getLayout(<Component {...pageProps} />)}
                                </ModalProvider>
                              </RtlLayout>
                            </ThemeLocalization>
                          </ThemeColorPresets>
                        </MotionLazyContainer>
                      </NotistackProvider>
                    </StepperProvider>
                  </ThemeProvider>
                </SettingsProvider>
              </DateTimeProvider>
            </CollapseDrawerProvider>
          </LocalizationProvider>
        </PersistGate>
        <BlockingLoader />
      </ReduxProvider>

    </>
  );
}

// ----------------------------------------------------------------------

MyApp.getInitialProps = async (context) => {
  const appProps = await App.getInitialProps(context);

  const cookies = cookie.parse(context.ctx.req ? context.ctx.req.headers.cookie || '' : document.cookie);

  const settings = getSettings(cookies);

  return {
    ...appProps,
    settings,
  };
};
